import { PlayerLayerTab } from '../types'

const encodePlayerLayerParams = ({
  playerId,
  gameId,
  matchId,
  activeTab,
}: {
  playerId: string
  gameId?: string
  matchId?: string
  activeTab: PlayerLayerTab
}) => {
  if (!gameId && !matchId) {
    return null
  }

  return (
    ((gameId && '1') || '0') +
    '|' +
    (gameId || matchId) +
    '|' +
    playerId +
    '|' +
    activeTab
  )
}

export default encodePlayerLayerParams
try {
    // @ts-ignore
    encodePlayerLayerParams.displayName = "encodePlayerLayerParams";
    // @ts-ignore
    encodePlayerLayerParams.__docgenInfo = { "description": "", "displayName": "encodePlayerLayerParams", "props": { "playerId": { "defaultValue": null, "description": "", "name": "playerId", "required": true, "type": { "name": "string" } }, "gameId": { "defaultValue": null, "description": "", "name": "gameId", "required": false, "type": { "name": "string" } }, "matchId": { "defaultValue": null, "description": "", "name": "matchId", "required": false, "type": { "name": "string" } }, "activeTab": { "defaultValue": null, "description": "", "name": "activeTab", "required": true, "type": { "name": "PlayerLayerTab" } } } };
    // @ts-ignore
    if (typeof STORYBOOK_REACT_CLASSES !== "undefined")
        // @ts-ignore
        STORYBOOK_REACT_CLASSES["src/components/PlayerLayer/lib/encodePlayerLayerParams.ts#encodePlayerLayerParams"] = { docgenInfo: encodePlayerLayerParams.__docgenInfo, name: "encodePlayerLayerParams", path: "src/components/PlayerLayer/lib/encodePlayerLayerParams.ts#encodePlayerLayerParams" };
}
catch (__react_docgen_typescript_loader_error) { }